export const BOOKING_LOCALES = ["fr", "de", "en"] as const;
export type BookingLocale = (typeof BOOKING_LOCALES)[number];

/** "fr-CH" → "fr"; anything unsupported → "en". */
export function toBookingLocale(locale: string | null | undefined): BookingLocale {
  const short = (locale ?? "").slice(0, 2).toLowerCase();
  return (BOOKING_LOCALES as readonly string[]).includes(short)
    ? (short as BookingLocale)
    : "en";
}

/**
 * The widget's language (Run 4): the snippet's data-locale, then a language
 * the studio fixed in Booking widget › Language, then the host page's
 * <html lang>, then the studio's own language. Anything else (no value, a
 * language the widget doesn't speak, the old "auto") falls through to the
 * next step; French when nothing is left.
 */
export function pickWidgetLocale(input: {
  snippet?: string | null;
  admin?: string | null;
  page?: string | null;
  studio?: string | null;
}): BookingLocale {
  const supported = (value: string | null | undefined): BookingLocale | null => {
    const short = (value ?? "").trim().slice(0, 2).toLowerCase();
    return (BOOKING_LOCALES as readonly string[]).includes(short) ? (short as BookingLocale) : null;
  };
  const fixed = (value: string | null | undefined) =>
    value && value !== "auto" ? supported(value) : null;
  return (
    fixed(input.snippet) ?? fixed(input.admin) ?? supported(input.page) ?? supported(input.studio) ?? "fr"
  );
}
